import {
  forwardRef,
  useEffect,
  useRef,
  InputHTMLAttributes,
  MutableRefObject,
} from "react";

interface IIndeterminateCheckbox extends InputHTMLAttributes<HTMLInputElement> {
  /**
   * The "some but not all selected" state. HTML exposes this only as a DOM
   * property, never as an attribute, so it has to be set through a ref.
   */
  indeterminate?: boolean;
}

const IndeterminateCheckbox = forwardRef<
  HTMLInputElement,
  IIndeterminateCheckbox
>(({ indeterminate, ...rest }, ref) => {
  const defaultRef = useRef<HTMLInputElement>(null);
  const resolvedRef = (ref ||
    defaultRef) as MutableRefObject<HTMLInputElement | null>;

  useEffect(() => {
    if (resolvedRef.current) {
      resolvedRef.current.indeterminate = Boolean(indeterminate);
    }
  }, [resolvedRef, indeterminate]);

  return (
    <input
      className="form-checkbox h-5 w-5 text-primary"
      type="checkbox"
      ref={resolvedRef}
      {...rest}
    />
  );
});

IndeterminateCheckbox.displayName = "IndeterminateCheckbox";

export default IndeterminateCheckbox;
